import CommentsIconButton from "../../../../ui/buttons/CommentsIconButton";

const ChecklistCommentsButton = ({
  tooltip = "Show Comment",
  active,
  comments,
  onClick,
}) => {
  return (
    <CommentsIconButton
      tooltip={tooltip}
      active={active}
      comments={comments}
      onClick={onClick}
    />
  );
};

export default ChecklistCommentsButton;
